import React from 'react';

const X = [34.6, 30.2, 35.8, 60.18, 79.032, 45.08, 61.10]
const Y = [78.02, 43.89, 72.90, 86.32, 75.34, 56.31, 96.51]
    
class LinealRegression extends React.Component {
    constructor() {
        super();
    }
    componentDidMount() {
        const { holder } = this;
        holder.x = X;
        holder.y = Y;
        holder.learningrate = 0.0004;
        holder.batchSize = 10;
    }
    render() {
        return (
            <div>
                <lineal-regression ref={_ref => this.holder = _ref} />
            </div>
        );
    }
}

export default LinealRegression;

export const textCode = `
import React from 'react';

const X = [34.6, 30.2, 35.8, 60.18, 79.032, 45.08, 61.10]
const Y = [78.02, 43.89, 72.90, 86.32, 75.34, 56.31, 96.51]
    
class LinealRegression extends React.Component {
    constructor() {
        super();
    }
    componentDidMount() {
        const { holder } = this;
        holder.x = X;
        holder.y = Y;
        holder.learningrate = 0.0004;
        holder.batchSize = 10;
    }
    render() {
        let { topvalue, bottomvalue,rotate,stack,barcolor,columnwidth,title, legends, exprt } = this.state
        return (
            <div>
                <lineal-regression ref={_ref => this.holder = _ref} />
            </div>
        );
    }
}

export default LinealRegression;
`

export const src = `
const X = [34.6, 30.2, 35.8, 60.18, 79.032, 45.08, 61.10]
const Y = [78.02, 43.89, 72.90, 86.32, 75.34, 56.31, 96.51]


const template = "<lineal-regression></lineal-regression>";

document.onreadystatechange = () => {
    if (document.readyState === "complete") {
        const sampleCode  = document.querySelector("._sampleDomElement");
        sampleCode.innerHTML = template
        const element = document.querySelector("lineal-regression")
        element.x = X;
        element.y = Y;
        element.learningrate = 0.0004;
        element.batchSize = 10;
    }
}
`



// WEBPACK FOOTER //
// ./src/samples/LinealRegressionReact.js